import { render, staticRenderFns } from "./ncrOrderChartWidget.vue?vue&type=template&id=4c1c4a48&"
import script from "./ncrOrderChartWidget.vue?vue&type=script&lang=js&"
export * from "./ncrOrderChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports